import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import {
  ColumnSetting,
  ColumnsOrderState,
  ColumnsVisibilityState,
  ColumnsWidthState,
  InvoiceData,
} from '../../dashboard/components/InvoiceSettings/types';
import invoiceSettingsState, {
  InvoiceSettingsStoreState,
} from '../states/invoiceSettingsState';

export const invoiceSettingsSlice = createSlice({
  name: 'invoiceSettings',
  initialState: invoiceSettingsState,
  reducers: {
    setInvoiceSettingsData: (
      state,
      action: PayloadAction<InvoiceData | null>
    ) => {
      state.data = action.payload;
      state.categoryIndex = 0;
      state.columnsState = action.payload?.columns_settings ?? [];
      state.columnsVisibilityState = null;
      state.columnsWidthState = null;
      state.columnsOrderState = null;
      state.tableWidth = null;
      state.tableRenderKey += 1;
      state.isEditMode = false;
    },
    setInvoiceSettingsLoading: (state, action: PayloadAction<boolean>) => {
      state.isLoading = action.payload;
    },
    setInvoiceSettingsSaving: (state, action: PayloadAction<boolean>) => {
      state.isSaving = action.payload;
    },
    setInvoiceSettingsReadOnly: (state, action: PayloadAction<boolean>) => {
      state.isReadOnly = action.payload;
    },
    setInvoiceEditMode: (state, action: PayloadAction<boolean>) => {
      state.isEditMode = action.payload;
    },
    setInvoiceSettingsError: (state, action: PayloadAction<string | null>) => {
      state.error = action.payload;
    },
    setInvoiceSettingsInvoiceId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.invoiceId = action.payload;
    },
    setInvoiceSettingsVendorId: (
      state,
      action: PayloadAction<string | null>
    ) => {
      state.vendorId = action.payload;
    },
    setInvoiceTableWidth: (state, action: PayloadAction<number | null>) => {
      state.tableWidth = action.payload;
    },
    setInvoiceColumnsVisibilityState: (
      state,
      action: PayloadAction<ColumnsVisibilityState | null>
    ) => {
      state.columnsVisibilityState = action.payload;
    },
    setInvoiceColumnsWidthState: (
      state,
      action: PayloadAction<ColumnsWidthState | null>
    ) => {
      state.columnsWidthState = action.payload;
    },
    setInvoiceColumnsOrderState: (
      state,
      action: PayloadAction<ColumnsOrderState | null>
    ) => {
      state.columnsOrderState = action.payload;
    },
    setInvoiceColumnsState: (state, action: PayloadAction<ColumnSetting[]>) => {
      state.columnsState = action.payload;
    },
    setDefaultColumnsSettings: (
      state,
      action: PayloadAction<ColumnSetting[] | null>
    ) => {
      state.defaultColumnsSettings = action.payload;
    },
    bumpInvoiceTableRenderKey: (state) => {
      state.tableRenderKey += 1;
    },
    resetInvoiceSettingsState: () => ({
      ...(invoiceSettingsState as InvoiceSettingsStoreState),
    }),
  },
});

export type { InvoiceSettingsStoreState };

export const {
  setInvoiceSettingsData,
  setInvoiceSettingsLoading,
  setInvoiceSettingsSaving,
  setInvoiceSettingsReadOnly,
  setInvoiceEditMode,
  setInvoiceSettingsError,
  setInvoiceSettingsInvoiceId,
  setInvoiceSettingsVendorId,
  setInvoiceTableWidth,
  setInvoiceColumnsVisibilityState,
  setInvoiceColumnsWidthState,
  setInvoiceColumnsOrderState,
  setInvoiceColumnsState,
  setDefaultColumnsSettings,
  bumpInvoiceTableRenderKey,
  resetInvoiceSettingsState,
} = invoiceSettingsSlice.actions;

export default invoiceSettingsSlice.reducer;
